import { format } from 'path';
import React, { useEffect, useState } from 'react';
import Store from '../../../core/Store';
import { Globals } from '../../../misc/helpers';
import './BleedoutTimer.css';
var currentSeconds = 240;
const store = new Store();
const BleedoutTimer = (props: any) => {
	const secondsDefaultValue = props.parameters?.startTimeInSeconds - (props?.parameters?.startTimeInSeconds?.timePenaltyInSeconds ? props.parameters.startTimeInSeconds.timePenaltyInSeconds : 0) ?? 240;

	const secondToChange = 3;//how often the timer color will be changed
	var redChange = false;
	var startDelay = false;

	let [seconds, setSeconds] = useState(secondsDefaultValue);
	let [maximumTime] = useState(secondsDefaultValue);

	let [isWhiteColor, setIsWhiteColor] = useState(true);
	let [isFaded, setIsFaded] = useState(false);
	let [isDelayed, setIsDelayed] = useState(false);
	
	function reset() {
		if(props.parameters.isTutorial) {
			currentSeconds = 240;
			setSeconds(240);
			return;
		}
		if(props.parameters.onTimeRanOut)
			props.parameters.onTimeRanOut();
		setSeconds(0);
	}

	function formatSeconds(seconds : number){
		let minutes = Math.floor(seconds / 60);
		let displayedSeconds = seconds % 60;
		return minutes + ':' + (displayedSeconds < 10 ? ('0' + displayedSeconds) : displayedSeconds);
	}
	
	useEffect(() => {
		store.set('secondsPassed-BC', (maximumTime - seconds));//set remained seconds
		if(props.parameters.isActive){
			if(currentSeconds > 200 && seconds < 10) {
				setSeconds(currentSeconds);
			}

			if(props.parameters.setRedEffect) {
				setIsWhiteColor(currentIsWhiteColor => !currentIsWhiteColor);
				redChange = true;
				setTimeout(() => {
					props.parameters.setRedEffect = false;
				}, 1000);
			}

			if(redChange === true) {
				setTimeout(() => {
					setIsWhiteColor(currentIsWhiteColor => !currentIsWhiteColor);
					redChange = false;
				}, 4000);
			}

			if(props.parameters.setDelayed) {
				setIsDelayed(false);
			} else {
				setIsDelayed(true);
				if(Globals.stopTimer) {
					setIsFaded(true);
				} else {
					setIsFaded(false);
				}
			}

			// if(props.parameters.setDelay) {
			// 	startDelay = true;
			// 	setTimeout(() => {
			// 		props.parameters.setDelay = false;
			// 	}, 1000);
			// }

			// if(startDelay === true) {
			// 	setTimeout(() => {
			// 		setIsDelayed(true);
			// 		setIsFaded(false);
			// 		startDelay = false;
			// 	}, 1600);
			// }

			if (seconds > 0) {
				setTimeout(() => {
					if(!Globals.stopTimer) {
						var sub = 1;

						if(props.parameters?.timePenaltyInSeconds) {
							sub += props.parameters.timePenaltyInSeconds;
							props.parameters.timePenaltyInSeconds = 0;
						}

						setSeconds((seconds :number) => {
							if(currentSeconds < seconds) {
								return currentSeconds;
							}
							currentSeconds = seconds - sub;
							return currentSeconds;
						});
					}
				}, 1000);
			} 
			else if (seconds <= 0) {
				reset();
			}
		}
	}, [props.parameters.isActive, seconds, Globals.stopTimer]);

	return (
		<div className={`bleedout-timer-background modal-disable-select ${isDelayed ? (isFaded ? 'timershown-fade-out' : 'timershown-fade-in') : 'bleedtimer-fade-in'}`}>
			<div className="bleedout-timer-container">
				<p className="timer-title">bleed out timer</p>
				<p className={`timer-body ${isWhiteColor ? 'animated-white' : 'animated-red'}`} style={{color: isWhiteColor ? 'white' : 'red'}}>{formatSeconds(seconds)}</p>
			</div>
		</div>
	);
};

export default BleedoutTimer;
